export default __webpack_public_path__ + "static/media/Thong bao 94_So tai chinh_Ghe go.1bf28fd5.pdf";